import React, { useState } from "react";
import { StyledCenterDiv } from "../../../../styles/MainStyles";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import { StatusSubprocess } from "../../../../model/Enums/StatusSubprocessEnum";
import { useAdministratorTach } from "../../../../context/AdministratorTachContext";

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;

interface IActionInformation {
    onHide: () => void;
    onMainActionClick: () => void;
    showRightButton: boolean;
    isValidSendJustify: boolean;
    handleJustifySubprocess: () => void;
    status: string;
}

const ActionInformation: React.FC<IActionInformation> = ({
    onHide,
    onMainActionClick,
    showRightButton,
    isValidSendJustify,
    handleJustifySubprocess,
    status,
}) => {
    const [showSendJustify, setShowSendJustify] = useState(false);
    const { dacPermission } = useAdministratorTach();

    const sendJustifyButton = (
        <BtnPrimary
            onClick={() => handleJustifySubprocess()}
            disabled={!isValidSendJustify}
        >
            Enviar Justificativa
        </BtnPrimary>
    );

    const justifyButton = dacPermission.hasPermission ? (
        <BtnPrimary
            style={{ display: showSendJustify ? "none" : "block" }}
            onClick={() => {
                onMainActionClick();
                setShowSendJustify(true);
            }}
        >
            Justificar
        </BtnPrimary>
    ) : null;

    return (
        <StyledCenterDiv>
            <DefaultButtonLink onClick={() => onHide()}>
                Fechar
            </DefaultButtonLink>
            {status === StatusSubprocess.PENDING &&
                (!showSendJustify && showRightButton
                    ? sendJustifyButton
                    : justifyButton)}
            {showSendJustify && sendJustifyButton}
        </StyledCenterDiv>
    );
};

export default ActionInformation;
